// source: https://github.com/apexcharts/apexcharts.js/blob/main/src/modules/Series.js

/**
 * ApexCharts Series Class for interaction with the Series of the chart.
 *
 * @module Series
 **/

export default class ApexSeries {
  constructor(ctx) {
    this.ctx = ctx;
    this.w = ctx.w;
  }

  getActiveConfigSeriesIndex(ignoreBars = false, order = 'asc') {
    const w = this.w;
    let activeIndex = 0;

    if (w.config.series.length > 1) {
      // active series flag is required to know if user has not deactivated via legend click
      const activeSeriesIndex = w.config.series.map((s, index) => {
        let hasBars = false;
        if (ignoreBars) {
          hasBars = w.config.series[index].type === 'bar' || w.config.series[index].type === 'column';
        }
        return s.data && s.data.length > 0 && !hasBars ? index : -1;
      });

      for (
        let a = order === 'asc' ? 0 : activeSeriesIndex.length - 1;
        order === 'asc' ? a < activeSeriesIndex.length : a >= 0;
        order === 'asc' ? a++ : a--
      ) {
        if (activeSeriesIndex[a] !== -1) {
          activeIndex = activeSeriesIndex[a];
          break;
        }
      }
    }

    return activeIndex;
  }
}
